import * as functions from 'firebase/functions';
import { functionsApp } from "@/services/firebase.service";

let activeFunctions = {};

export async function callCloudFunction(name, params) {

  try {

    /*
    Para llamar una cloud function tengo que hacer dos pasos:
    - instanciarla trayendo desde firebase su activador -> esto lo guardo a medida que se van llamando para ahorrar tiempo
    - llamarla -> esto se ejecutará cada vez que se necesite
    */
    if (!activeFunctions[name]) {
      activeFunctions[name] = functions.httpsCallable(functionsApp, name);
    }

    return await activeFunctions[name](params);

  } catch (error) {

    return {
      message: `Se intentó llamar a la función ${name} con los siguientes parámetros: ${JSON.stringify(params)}`,
      functionError: error.message
    }

  }

}